'use strict';

// DO NOT USE THIS ANYMORE, IT'S BUGGY !

function init () {
  $.fn.extend({
    prettifyBigNumbers: function () {
      var nbrRegExp = /([\D]{1})([\d]{4,})([\D]{1})/g;

      return this.each(function () {
        var $this = $(this);
        var inner = $this.html();
        var replacedInner;

        if ($this.find('a').length > 0) {
          return;
        }

        replacedInner = inner.replace(nbrRegExp,
          function (match, p1, p2, p3) {
            if (p1 === '.' || p1 === ',') {
              return match;
            }

            var returnStr = '</abbr>' + p3;
            var beginStr = p1 + '<abbr class="big-nbr-container">';
            var numberLength = p2.length;
            var numberLoop = Math.floor(numberLength / 3);
            var numberRest = numberLength % 3;
            var i = 1;

            while (i <= numberLoop) {
              if (i === numberLoop && numberRest === 0) {
                returnStr = p2.substr(-3 * i, 3) + returnStr;
              } else {
                returnStr = '<abbr>' +
                  p2.substr(-3 * i, 3) +
                  '</abbr>' +
                  returnStr;
              }
              i++;
            }
            i--;
            returnStr =
              beginStr + p2.substr(
                (-3 * i) - numberRest, numberRest
              ) + returnStr;
            return returnStr;
          }
        );
        return $this.html(replacedInner);
      });
    }
  });
}

module.exports = {
  init: init
};
